var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-container"},[(_vm.isLoading)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"spinner",attrs:{"uk-spinner":"ratio: 3"}})]):_vm._e(),(!_vm.isLoading)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }